<template functional>
    <div class="v2_info-popup__body px-2">
      <p>Use Connect to immediately gauge physicians’ interest in your open role and precisely connect your opportunity to those interested candidates. </p>
      <ul class="list-style-disc pl-3">
        <li>
          Select and define required Job Criteria to build your job.
        </li>
        <li>Assess “Number of Matches” to see the number of candidates interested in your opportunity.</li>
        <li>
          Click “Connect Your Opportunity” to inform matching candidates their dream job awaits.
        </li>
        <li>Register the opportunity and pay Phairify to alert those candidates to contact you about it. </li>
       </ul>
    </div>
  </template>
  
  <script>
  export default {
    name: 'ExchangeInfoPopup',
  };
  </script>
  
  <style scoped lang="scss">
  .v2_info-popup__body {
    ul {
      list-style-type: none;
      padding: 0;
    }
  }
  ul {
    margin: 0;
    padding: 0;
  }

  ul ul {
    margin-left: 20px;
  }
  ul ul li{
    list-style-type: circle;
  }
  ul li{
    margin-bottom: 5px;
  }
  ul li ul{
    margin-top:15px;
    margin-bottom: 20px;
  }
  </style>
  